/* eslint-disable import/no-unresolved */
import React from 'react';
import { Link } from 'gatsby';

import { IoIosArrowRoundForward } from 'react-icons/io';
import lendingblockLogoSVG from 'assets/resources/pages/lendingblock_logo.svg';
import OptimizedImage from '../../../OptimizedImage';
import ImgHTML from '../../../ImgHTML';
import useSitemap from '../../../../graphql/staticQueries/useSitemap';

const CustomSoftwareContent = () => {
  const pages = useSitemap();
  const desiredPage = '/case-studies/lendingblock/';
  const altPage = '/case-studies/';
  const linkTo = pages.includes(desiredPage) ? desiredPage : altPage;
  return (
    <div className="main-beam top">
      <div className="row">
        <div className="col-lg-5 col-mn-12">
          <div className="desc-section">
            <h2 className="subtitle bigger">
              Our remote team of developers will help you{' '}
              <span>build a custom software</span> from scratch.
            </h2>
            <div className="content">
              <p>
                We help to build systems designed for your individual business
                requirements and needs. Delivering a new IT product or system
                that serves unique processes requires custom development.
              </p>
              <p>
                <strong>You will get:</strong>
              </p>
              <ul>
                <li>
                  A system that answers your business needs and requirements
                  exactly
                </li>
                <li>An easily scalable and flexible solution</li>
                <li>Full ownership of the system</li>
              </ul>
              <p>
                We have delivered and supported business systems for a broad
                scope of industries, from telecommunications and manufacturing
                to blockchain based cryptocurrency solutions. Based on our
                experience, we develop meaningful products that truly meet
                customers requirements.
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-7 col-md-12">
          <div className="image-section">
            <OptimizedImage
              src="pages/lendingblock_photo.png"
              className="img-fluid"
              alt="lendingblock photo"
              title="lendingblock photo"
            />
            <Link to={linkTo} className="company-link">
              <div className="logo">
                <ImgHTML
                  src={lendingblockLogoSVG}
                  className="img-fluid"
                  alt="lendingblock-logo"
                />
              </div>
              <div className="link">
                <div className="read-more">
                  See related project <IoIosArrowRoundForward />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSoftwareContent;
